export { ConsentAndRelationshipModal } from './components';

export {
    useDeleteTrackedPropertyMutation,
    type DeleteTrackedPropertyMutation,
} from './queries';
